const Engagement = () => {
  return (
    <div className="engagement_container">
      <div className="mobile_page_title">Engagmements</div>
      <div className="engagement_title2_container">
        <div className="titleE">Territoire</div>
      </div>
      <div className="engagement_container_textB">
        <div className="text_W text_E">
          Dans l’idée de favoriser l’emploi et l’économie, nous nous entourons
          de fournisseurs locaux, concernés par notre démarche écologique. Cela
          permet de réduire l’émission de gaz à effet de serre lors des
          déplacements et transports du matériel. Cet acte contribue à stimuler
          le tissu local et favorise notre implantation en terre montendraise.
        </div>
      </div>
      <div className="engagement_title2_container">
        <div className="titleE">Tri des déchets</div>
      </div>
      <div className="engagement_container_textB">
        <div className="text_W text_E">
          Pour cette quinzième édition, nous voulons mettre l’accent sur le tri
          des déchets et allons mettre en place des poubelles à deux bacs avec
          des panneaux explicatifs. D’autre part, nous voulons limiter au
          maximum le gaspillage, ainsi toute la vaisselle de notre espace
          bénévole est réutilisable et nos déchets alimentaires sont compostés !
        </div>
      </div>
      <div className="engagement_title2_container">
        <span className="titleE">Communication</span>
      </div>
      <div className="engagement_container_textB">
        <div className="text_W text_E">
          Nous renforçons notre présence sur Internet grâce à notre site et aux
          réseaux sociaux. Nous pouvons ainsi réduire les quantités d’impression
          pour l’affichage, tout en s’assurant d’une diffusion large de
          l’événement. Nos engagements Décors Enfin, la décoration du engagement
          est réalisée à partir de matériaux de récupération. Une grande partie
          du matériel technique est mis à disposition par les collectivités et
          les partenaires afin de privilégier la mise en commun.
        </div>
      </div>
      <div className="engagement_title2_container">
        <span className="titleE">Verres réutilisables</span>
      </div>
      <div className="engagement_container_textB">
        <div className="text_W text_E">
          À maintes reprises, nous avons souhaité que les boissons soient
          servies dans des verres consignés. Il y a six ans, nous avons mis en
          service 1000 verres réutilisables. Ils ont de nouveau servi pour les
          éditions suivantes, et nous n’en commandons que peu de nouveaux chaque
          année.
        </div>
      </div>
      <div className="engagement_title2_container">
        <span className="titleE">Toilettes sèches</span>
      </div>
      <div className="engagement_container_textB">
        <div className="text_W text_E">
          Notre équipe tient à disposition, des toilettes sèches, symboles de
          notre engagement pour le respect de l’environnement. Un texte
          descriptif invite le public à prendre soin de ce lieu, ce qui
          constitue une démarche de sensibilisation.
        </div>
      </div>
    </div>
  );
};

export default Engagement;
